/**
 * Page Transition Component
 * Provides smooth fade animations between route changes
 * Respects reduced motion preferences
 *
 * SIMPLIFIED: Uses key-based re-mounting to ensure fresh content on navigation
 */

import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { useReducedMotion } from '@/lib/hooks';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

export const PageTransition = memo(function PageTransition({ children, className = '' }: PageTransitionProps) {
  const location = useLocation();
  const prefersReducedMotion = useReducedMotion();

  // If reduced motion, render without animation wrapper
  if (prefersReducedMotion) {
    return <div className={className}>{children}</div>;
  }

  // Use pathname as key to force re-mount and trigger animation on route change
  // This ensures fresh content is always rendered immediately
  return (
    <div
      key={location.pathname}
      className={`motion-safe:animate-fade-in ${className}`}
    >
      {children}
    </div>
  );
});
